import { render } from "./App.vue?vue&type=template&id=7fca2cbc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7fca2cbc&lang=scss"

import exportComponent from "/Users/Max/Documents/Projekte/slf-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__